<template>
  <div class="row">
    <div class="column twelve">
      <div
          class="relative -top-90 -mb-90 mx-auto rounded shadow search-input-container block">
        <div class="flex">
          <input v-model="search" class="search-input" type="text"
                 placeholder="Search by address, zip, mls #, subdivision, or city">
          <button class="search-input-button icon-m-search"
                  aria-label="Search"></button>
        </div>


        <div class="border-t border-gray100 border-solid">
          <div class="flex">
            <div class="listing-filter-category" @click.stop
                 @click="toggleFilter('price')" :class="priceClass">
              <div class="mr-15 text-gray600">{{ priceText }}</div>

              <div class="listing-filter-category-dropdown-arrow"></div>

              <div @click.stop class="listing-filter-options">
                <div class="flex items-center p-40 bg-white rounded">
                  <SearchInput v-model="price.min" placeholder="Min"
                               unitBefore="$"/>

                  <div class="text-gray100 mx-7">-</div>

                  <SearchInput v-model="price.max" placeholder="Max"
                               unitBefore="$"/>
                </div>
              </div>
            </div>
            <div class="hidden md:flex listing-filter-category" @click.stop
                 @click="toggleFilter('beds')" :class="bedsClass">
              <div class="mr-15 text-gray600">{{ bedsText }}</div>

              <div class="listing-filter-category-dropdown-arrow"></div>

              <div @click.stop class="listing-filter-options">
                <div class="flex items-center p-40 bg-white rounded">
                  <SearchInput v-model="beds.min" placeholder="Min"/>

                  <div class="text-gray100 mx-7">-</div>

                  <SearchInput v-model="beds.max" placeholder="Max"/>
                </div>
              </div>
            </div>
            <div class="hidden md:flex listing-filter-category" @click.stop
                 @click="toggleFilter('baths')" :class="bathsClass">
              <div class="mr-15 text-gray600">{{ bathsText }}</div>

              <div class="listing-filter-category-dropdown-arrow"></div>

              <div @click.stop class="listing-filter-options">
                <div class="flex items-center p-40 bg-white rounded">
                  <SearchInput v-model="baths.min" placeholder="Min"/>

                  <div class="text-gray100 mx-7">-</div>

                  <SearchInput v-model="baths.max" placeholder="Max"/>
                </div>
              </div>
            </div>
            <div
                class="hidden lg:flex relative flex-grow px-25 py-30 cursor-pointer listing-filter-category"
                @click.stop @click="toggleFilter('type')" :class="typeClass"
            >
              <div class="text-gray600 mr-15 ">Type</div>
              <div class="listing-filter-category-dropdown-arrow"></div>

              <div @click.stop class="listing-filter-options">
                <div
                    class="flex flex-col items-start p-40 bg-white rounded w-300">
                  <vCheck v-for="value, option in typeOptions"
                          v-model="typeOptions[option]" :label="formatLabel(option)"
                          :key="'more-type-'+option" class="py-8"/>
                  <vCheck v-model="onlyCondos['condominium']" label="Only Condos"
                          class="py-8"/>
                  <!-- <vSelect :options="typeOptions" v-model="propertyType" class="listing-search-input-container w-full" /> -->
                </div>
              </div>
            </div>
            <div
                class="relative flex-grow px-25 py-30 cursor-pointer listing-filter-category"
                @click.stop @click="toggleFilter('more')" :class="moreClass"
            >
              <div class="text-gray600">More <span class="inline md:hidden">Filters</span>
              </div>
              <div class="listing-filter-category-dropdown-arrow"></div>

              <div @click.stop class="listing-filter-options more">
                <div class="flex flex-wrap">

                  <!-- Communities -->
                  <!-- <div class="w-full">
                    <ul class="nav-links z-max">
                      <li class="nav-item">
                        <div class="dropdown">
                          <ul>
                            <li><a @click.stop @click=" community = 'Mayo Lake' ">Mayo Lake</a></li>
                            <li><a @click.stop @click=" community = 'Alamance County' ">Alamance County</a></li>
                            <li><a @click.stop @click=" community = 'Person County' ">Person County</a></li>
                            <li><a @click.stop @click=" community = 'Hyco Lake' ">Hyco Lake</a></li>
                            <li><a @click.stop @click=" community = 'Wake County' ">Wake County</a></li>
                            <li><a @click.stop @click=" community = 'Orange County' ">Orange County</a></li>
                            <li><a @click.stop @click=" community = 'Durham County' ">Durham County</a></li>
                          </ul>
                        </div>
                        <a class="text-gray600 border">
                          Community: <em>{{ community || "None Selected" }}</em>
                        </a>
                      </li>
                    </ul>
                  </div> -->

                  <!-- Beds -->
                  <div class="md:hidden sm:w-1/2 sm:pr-25">
                    <div class="text-gray600 my-15">Bedrooms</div>
                    <div class="flex justify-between items-center">
                      <SearchInput v-model="beds.min" placeholder="Min"/>
                      <div class="text-gray100 mx-7">-</div>
                      <SearchInput v-model="beds.max" placeholder="Max"/>
                    </div>
                  </div>
                  <!-- Bathrooms -->
                  <div class="md:hidden sm:w-1/2 sm:pr-25">
                    <div class="text-gray600 my-15">Bathrooms</div>
                    <div class="flex justify-between items-center">
                      <SearchInput v-model="baths.min" placeholder="Min"/>
                      <div class="text-gray100 mx-7">-</div>
                      <SearchInput v-model="baths.max" placeholder="Max"/>
                    </div>
                  </div>
                  <!-- Type -->
                  <div class="w-full lg:hidden md:mt-0 mt-15">
                    <div class="text-gray600 mb-15">Type</div>
                    <vCheck v-for="value, option in typeOptions"
                            v-model="typeOptions[option]"
                            :label="formatLabel(option)" :key="'type-'+option"
                            class="py-8"/>
                    <!-- <vSelect :options="typeOptions" v-model="propertyType" class="listing-search-input-container w-full" /> -->
                  </div>
                  <!-- Communities -->
                  <div class="w-full sm:w-3/4 sm:pr-25 mt-15">
                    <vSelect label="Communities" :options="communities"
                             v-model="community" class="w-full"/>
                  </div>
                  <!-- Water Front -->
                  <div class="w-full sm:w-1/4 sm:pr-25 mt-15 sm:pt-0">
                    <div class="text-gray600 mb-15">Water Front</div>
                    <vCheck v-model="waterfront" class="flex w-full"
                            style="height: 25px;"/>
                  </div>

                  <!-- Square footage -->
                  <div class="w-full sm:w-1/2 sm:pr-25 mt-15">
                    <div class="text-gray600 my-15">Square Footage</div>
                    <div class="flex justify-between items-center">
                      <SearchInput v-model="area.min" placeholder="Min"
                                   unit-after="sqft"/>
                      <div class="text-gray100 mx-7">-</div>
                      <SearchInput v-model="area.max" placeholder="Max"
                                   unit-after="sqft"/>
                    </div>
                  </div>
                  <!-- Features -->
                  <div class="w-full sm:w-1/2 mt-15">
                    <div class="text-gray600 my-15">Features</div>
                    <SearchInput type="text" class="w-full" v-model="features"
                                 placeholder="High Ceilings, Pool, etc."/>
                  </div>
                  <!-- Status -->
                  <div class="w-full sm:w-1/2 sm:pr-25 mt-15">
                    <vSelect label="Status" :options="statusOptions"
                             v-model="status" class="w-full"/>
                  </div>
                  <!-- Lot Size -->
                  <!-- <div class="w-full sm:w-1/2 sm:pr-25 mt-15">
                    <div class="text-gray600 my-15">Lot Size</div>
                    <div class="flex justify-between items-center">
                      <SearchInput v-model="lot.min" placeholder="Min" unit-after="sqft" />
                      <div class="text-gray100 mx-7">-</div>
                      <SearchInput v-model="lot.max" placeholder="Max" unit-after="sqft" />
                    </div>
                  </div> -->
                  <!-- Year Built -->
                  <div class="w-full sm:w-1/2 mt-15">
                    <div class="text-gray600 my-15">Min. Year Built</div>
                    <SearchInput type="text" class="w-full" v-model="minyear"
                                 placeholder="1920"/>
                  </div>
                  <!-- Agents -->
                  <div class="w-full sm:w-1/2 sm:pr-25 mt-15">
                    <vSelect label="Agents" :options="agents" v-model="agent"
                             class="w-full"/>
                  </div>
                  <!-- Brokers -->
                  <div class="w-full sm:w-1/2 sm:pr-25 mt-15">
                    <div class="text-gray600 my-15">Only West and Woodall
                      Listings
                    </div>
                    <vCheck v-model="wwonly" value="1" class="flex w-full"
                            style="height: 25px;"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from './search-input.vue';
import vSelect from '../general/v-select.vue';
import vCheck from '../general/v-check.vue';
import addCommas from '../../helpers/addCommas';
import formatLabel from '../../helpers/formatLabel';

// Builds the SimplyRETS query string for the residential listings screen.
export default {
  props: {
    modelValue: { type: String, default: '' },
    initialSearch: { type: String, default: '' },
    initialType: { type: String, default: '' },
    initialCommunity: { type: String, default: '' },
    windowSize: { type: String, default: 'md' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      search: '',
      minyear: '',
      community: this.initialCommunity,
      communities: [],
      communityFilters: {},
      waterfront: '',
      status: '',
      selectedFilter: null,
      features: '',
      agent: null,
      wwonly: null,
      price: {
        min: '10000',
        max: ''
      },
      beds: {
        min: '',
        max: ''
      },
      baths: {
        min: '',
        max: ''
      },
      area: {
        min: '',
        max: ''
      },
      lot: {
        min: '',
        max: ''
      },
      statusOptions: {
        "ComingSoon": "Coming Soon",
        "Active": "Active",
        "Pending": "Pending",
        "ActiveUnderContract": "Under Contract",
        "Closed": "Closed",
      },
      typeOptions: {
        residential: true,
        multifamily: true,
        land: true,
      },
      onlyCondos: {
        condominium: false,
      },
      agents: {"": ""},
    };
  },
  computed: {
    priceActive() {
      return this.price.min || this.price.max ? true : false;
    },
    priceText() {
      const min = addCommas(this.price.min);
      const max = addCommas(this.price.max);

      if (min && max) {
        return `$${min} - $${max}`;
      } else if (min) {
        return `From $${min}`;
      } else if (max) {
        return `Under $${max}`;
      } else {
        return 'Price';
      }
    },
    bedsActive() {
      return this.beds.min || this.beds.max ? true : false;
    },
    bedsText() {
      const min = this.beds.min;
      const max = this.beds.max;

      if (min && max) {
        return `${min} - ${max}`;
      } else if (min) {
        return `${min}+`;
      } else if (max) {
        return `Up to ${max}`;
      } else {
        return 'Beds';
      }
    },
    bathsActive() {
      return this.baths.min || this.baths.max ? true : false;
    },
    bathsText() {
      const min = this.baths.min;
      const max = this.baths.max;

      if (min && max) {
        return `${min} - ${max}`;
      } else if (min) {
        return `${min}+`;
      } else if (max) {
        return `Up to ${max}`;
      } else {
        return 'Baths';
      }
    },
    typeActive() {
      // As long as they're not all checked, or all unchecked, return true
      var lastOption = null
      for (var option in this.typeOptions) {
        var optionValue = this.typeOptions[option]
        if (!(lastOption === null) && optionValue != lastOption) {
          return true
        }
        lastOption = optionValue
      }
    },
    moreActive() {
      return (
          this.area.min ||
          this.area.max ||
          this.minyear ||
          this.community ||
          this.waterfront ||
          this.status ||
          this.features ||
          this.agent ||
          this.wwonly ||
          (this.typeActive && ['sm', 'md'].includes(this.windowSize)) ||
          ((this.beds.min || this.beds.max) && this.windowSize == 'sm') ||
          ((this.baths.min || this.baths.max) && this.windowSize == 'sm')) ? true : false;
    },
    priceClass() {
      var priceClass = ''
      if (this.priceActive) {
        priceClass += "listing-filter-category-active "
      }
      if (this.selectedFilter == "price") {
        priceClass += "active "
      }
      return priceClass
    },
    bedsClass() {
      var bedsClass = ''
      if (this.bedsActive) {
        bedsClass += "listing-filter-category-active "
      }
      if (this.selectedFilter == "beds") {
        bedsClass += "active "
      }
      return bedsClass
    },
    bathsClass() {
      var bathsClass = ''
      if (this.bathsActive) {
        bathsClass += "listing-filter-category-active "
      }
      if (this.selectedFilter == "baths") {
        bathsClass += "active "
      }
      return bathsClass
    },
    typeClass() {
      var typeClass = ''
      if (this.typeActive) {
        typeClass += "listing-filter-category-active "
      }
      if (this.selectedFilter == "type") {
        typeClass += "active "
      }
      return typeClass
    },
    moreClass() {
      var moreClass = ''
      if (this.moreActive) {
        moreClass += "listing-filter-category-active "
      }
      if (this.selectedFilter == "more") {
        moreClass += "active "
      }
      return moreClass
    },
  },
  mounted() {
    //console.log('agents search-listings mounted')
    window.addEventListener('click', this.closeModals);

    // If there's something in the hash, parse it out
    if (window.location.search) {
      var hash = window.location.search
      this.parseHash(hash)
    }

    this.emitSearchParams()
    this.fetchCommunities();
  },
  beforeUnmount() {
    window.removeEventListener('click', this.closeModals);
  },
  watch: {
    'onlyCondos.condominium'(newValue) {
      if (newValue) {
        for (let option in this.typeOptions) {
          this.typeOptions[option] = false;
        }
      }
    },
    typeOptions: {
      handler(newValue) {
        for (let option in newValue) {
          if (newValue[option]) {
            this.onlyCondos.condominium = false;
            break;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    formatLabel,
    parseHash(url) {
      const vm = this

      var queryIndex = {
        'q': 'search',
        'minyear': 'minyear',
        'water': 'waterfront',
        'features': 'features',
        'status': 'status',
        'minprice': 'price',
        'maxprice': 'price',
        'minbeds': 'beds',
        'maxbeds': 'beds',
        'minbaths': 'baths',
        'maxbaths': 'baths',
        'minarea': 'area',
        'maxarea': 'area',
        'agent': 'agent',
        'wwonly': 'wwonly',
        'community': 'community',
      }

      var query = url.split('?')[1]
      var vars = query.split('&');

      for (var i in vars) {
        if (vars[i] === true) {
          continue
        }
        var pair = vars[i].split('=');
        var key = decodeURIComponent(pair[0])
        var value = decodeURIComponent(pair[1])

        if (key in queryIndex) {
          var vueKey = queryIndex[key]
          if (key == 'minprice' && value <= 1) {
            continue
          } else if (key == 'minyear') {
            //preserve min year value
            this.minyear = value
          } else if (key.includes('min')) {
            vm[vueKey]['min'] = value
          } else if (key.includes('max')) {
            vm[vueKey]['max'] = value
          } else {
            vm[vueKey] = value
          }
        } else if (key == 'type') {
          if (value in vm.typeOptions) {
            vm.typeOptions[value] = true
          }
        } else if (['neighborhoods', 'counties'].includes(key)) {
          for (var community in vm.communityFilters) {
            var filters = vm.communityFilters[community].split('&')[0].split('=')[1]

            if (value.includes('&')) {
              var formattedValue = value.split('&')[0].split('=')[1]
            } else {
              var formattedValue = value
            }

            if (formattedValue == filters) {
              vm['community'] = community
            }
          }
        }

      }

    },
    closeModals() {
      this.selectedFilter = null
    },
    toggleFilter(filter) {
      if (this.selectedFilter != filter) {
        this.selectedFilter = filter
      } else {
        this.selectedFilter = null
      }
    },
    resetFilters() {
      this.search = '';
      this.minyear = '';
      this.community = '';
      this.waterfront = '';
      this.status = '';
      this.selectedFilter = null;
      this.features = '';
      this.agent = null;
      this.wwonly = null;
      this.price = {
        min: '10000',
        max: ''
      };
      this.beds = {
        min: '',
        max: ''
      };
      this.baths = {
        min: '',
        max: ''
      };
      this.area = {
        min: '',
        max: ''
      };
      this.lot = {
        min: '',
        max: ''
      };
      this.typeOptions = {
        residential: true,
        multifamily: true,
        land: true,
      };
      this.onlyCondos = {
        condominium: false,
      };

      this.$nextTick(() => {
        this.emitSearchParams();
      });
    },
    emitSearchParams() {
      let searchParams = "";
      let secondarySearch = '';

      if (this.search) {
        // Convert this.search to lowercase
        const lowercasedSearch = this.search.toLowerCase();

        // Check if 'ln' is present and add 'lane'
        if (/\bln\b/.test(lowercasedSearch) && !/\blane\b/.test(lowercasedSearch)) {
          secondarySearch = lowercasedSearch.replace(/\bln\b/, 'lane');
        }

        // Check if 'lane' is present and add 'ln'
        if (/\blane\b/.test(lowercasedSearch) && !/\bln\b/.test(lowercasedSearch)) {
          secondarySearch = lowercasedSearch.replace(/\blane\b/, 'ln');
        }

        if (secondarySearch) {
          searchParams += "q=" + encodeURI(this.search) + '&q=' + encodeURI(secondarySearch) + "&";
        } else {
          searchParams += "q=" + encodeURI(this.search) + "&";
        }
      }

      if (this.minyear) {
        searchParams += "minyear=" + encodeURI(this.minyear) + "&"
      }
      if (this.waterfront) {
        searchParams += "water=" + encodeURI(this.waterfront) + "&"
      }
      if (this.status) {
        searchParams += "status=" + encodeURI(this.status) + "&"
      } else {
        searchParams += 'status=Active&status=Pending&status=ComingSoon&status=ActiveUnderContract&'
      }
      if (this.typeActive) {
        for (var option in this.typeOptions) {
          if (this.typeOptions[option]) {
            searchParams += "type=" + encodeURI(option) + "&"
          }
        }
      } else {
        searchParams += 'type=residential&type=multifamily&type=land&'
      }
      if (this.onlyCondos['condominium']) {
        searchParams += "subtype=condominium&"
      }
      if (this.features) {
        let features = this.features.split(",")
        for (var feature of features) {
          searchParams += "features=" + encodeURI(feature) + "&"
        }
      }
      if (this.community) {
        let community = this.community
        searchParams += this.communityFilters[community]
      }
      if (this.price.min) {
        searchParams += "minprice=" + encodeURI(this.price.min) + "&"
      } else {
        searchParams += "minprice=10000&"
      }
      if (this.price.max) {
        searchParams += "maxprice=" + encodeURI(this.price.max) + "&"
      }
      if (this.beds.min) {
        searchParams += "minbeds=" + encodeURI(this.beds.min) + "&"
      }
      if (this.beds.max) {
        searchParams += "maxbeds=" + encodeURI(this.beds.max) + "&"
      }
      if (this.baths.min) {
        searchParams += "minbaths=" + encodeURI(this.baths.min) + "&"
      }
      if (this.baths.max) {
        searchParams += "maxbaths=" + encodeURI(this.baths.max) + "&"
      }
      if (this.area.min) {
        searchParams += "minarea=" + encodeURI(this.area.min) + "&"
      }
      if (this.area.max) {
        searchParams += "maxarea=" + encodeURI(this.area.max) + "&"
      }
      if (this.agent) {
        searchParams += "agent=" + encodeURI(this.agent) + "&"
      }
      if (this.wwonly) {
        searchParams += "wwonly=" + encodeURI('1') + "&"
      }
      this.$emit('update:modelValue', searchParams)
    },

    async fetchCommunities() {
      try {
        const response = await fetch('/communities.json');
        const data = await response.json();

        // Populate communities array
        this.communities = data.data.map(item => item.title);

        // Populate communityFilters object
        data.data.forEach(item => {
          const communityKey = item.title;
          let filterValue = '';

          if (item.communityType === 'county') {
            filterValue = `counties=${encodeURIComponent(item.communityName.toLowerCase())}&`;
          } else if (item.communityType === 'lake') {
            filterValue = `neighborhoods=${encodeURIComponent(item.communityName.toLowerCase() + ' lake')}&`;
          } else if (item.communityType === 'city') {
            filterValue = `cities=${encodeURIComponent(item.communityName.toLowerCase())}&`;
          }

          this.communityFilters[communityKey] = filterValue;
        });
      } catch (error) {
        console.error('Error fetching communities:', error);
      }
    },
  },
  created() {
    var vm = this

    this.search = this.initialSearch;
    var initialType = this.initialType
    var typeOptions = this.typeOptions

    // If the type is set in the qs and it's a valid type
    if (initialType && initialType in typeOptions) {
      // Loop through types and set only the initial type to true
      for (var option in typeOptions) {

        if (initialType == option) {
          typeOptions[option] = true
        } else {
          typeOptions[option] = false
        }

      }
    }

    // Set agents
    this.agents = window.wwAgents
  },
  updated() {
    this.emitSearchParams()
  },
  components: {
    SearchInput,
    vSelect,
    vCheck
  }
};
</script>
